import axios, { AxiosError } from "axios";
import { convertToCamelCase } from "@/utils/parser";
import { GetTextViewRequest, GetVarientRequest } from "@/types/requests";
import { GetTableOfContentsResponse, GetTextViewResponse, GetVarientResponse } from "@/types/responses";

const BASE_URL = "/api";

export async function getTableOfContents() {
  try {
    const url = `${BASE_URL}/book/table_of_contents`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return {
      tableOfContents: response.data.table_of_contents,
      pageAction: response.data.page_action,
      slug: response.data.slug,
    } as GetTableOfContentsResponse;
  } catch (error: unknown) {
    throw new Error("An unexpected error occurred");
  }
}

export async function getTextView(request: GetTextViewRequest) {
  try {
    const url = `${BASE_URL}/book/text_view/${request.h3Slug}`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return convertToCamelCase(response.data) as GetTextViewResponse;
  } catch (error: unknown) {
    throw new Error("An unexpected error occurred");
  }
}

export async function getVarient(request: GetVarientRequest) {
  try {
    const url = `${BASE_URL}/book/varient`;

    const response = await axios.post(
      url,
      {
        idWord: request.idWord,
        idGroup: request.idGroup,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return convertToCamelCase(response.data) as GetVarientResponse;
  } catch (error: unknown) {
    throw new Error("An unexpected error occurred");
  }
}
